<script>
import MyVideoPlayer from "@/components/SliderVideo/MyVideoPlayer.vue";
import VideoSlideItem from "./VideoSlideItem.vue";
import {fnCopy} from "@/util/fnCopy";
import {checkLoginWidthAppMessage, sendAppMessage} from "@/util/sendAppMessage";
import {Dialog, Toast} from "vant";
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import GiftPanel from "../gift/GiftPanel.vue";
import CommentPanel from "@/components/SliderVideo/Comment/CommentPanel.vue";

export default {
    name: "VideoSlider",
    components: {
        CommentPanel,
        GiftPanel,
        VideoSlideItem,
        MyVideoPlayer,
        Swiper, SwiperSlide
    },
    props: {
        videoList: {
            type: Array,
            default: () => []
        },
        showTitle: {
            type: Boolean,
            default: true
        },
        backGoHome: {
            type: Boolean,
            default: false,
        }
    },
    emits: ["more"],
    data() {
        return {
            giftList: [],
            giftOtherData: null,
            currentIndex: 0, // 当前视频索引
            isPlaying: false, // 是否正在播放
            videPlayerList: new WeakMap(), // 视频元素引用列表
            maxCacheCount: 3, // 最大缓存数量
            cacheIndexList: [], // 缓存视频索引列表
            isFullScreen: false, // 是否全屏
            loadMoreCount: 1, // 剩余三个时加载更多
            loadedMoreCount: -1, // 记录上次加载更多时的videoList长度
            giftCourseId: null,
            swiperOption: {
                direction: 'vertical'
            },
        };
    },
    computed: {
        userInfo() {
            return this.$store.getters.getUserInfo;
        },
        getCacheIndex() {
            let totalItems = this.videoList.length;
            let indices = [];

            // 保证 maxCacheCount 至少是 1，因为它包含当前下标
            const halfCacheCount = Math.floor((this.maxCacheCount - 1) / 2);

            // 正常获取前后下标的范围
            let startIndex = Math.max(0, this.currentIndex - halfCacheCount);
            let endIndex = Math.min(totalItems, this.currentIndex + halfCacheCount);

            // 调整范围以确保获取到 maxCacheCount 个下标
            while (endIndex - startIndex + 1 < this.maxCacheCount) {
                if (startIndex > 0) {
                    startIndex--; // 优先向前扩展
                } else if (endIndex < totalItems - 1) {
                    endIndex++; // 向后扩展
                } else {
                    break; // 无法进一步扩展时，退出循环
                }
            }

            // 生成最终的下标数组
            for (let i = startIndex; i <= endIndex; i++) {
                indices.push(i);
            }

            return indices;
        }
    },
    mounted() {
        this.getGiftListList();
        this.addFullScreenEvent();
        window.$bus.$on("refreshComment", this.onRefreshCommentList);
    },
    beforeDestroy() {
        this.removeFullScreenEvent();
        window.$bus.$off("refreshComment", this.onRefreshCommentList);
    },
    watch: {
        // currentIndex() {
        //   this.cacheIndexList = this.getIndicesAroundCurrent(this.currentIndex, this.maxCacheCount, this.videoList.length);
        //   this.stop();
        //   this.play();
        // }
    },
    methods: {
        getGiftListList() {
            this.$axios.get("/gift/getGiftList").then(res => {
                this.giftList = res.data;
                this.giftOtherData = res.other_data;
            })
        },
        addFullScreenEvent() {
            document.addEventListener("fullscreenchange", this.onFullscreenChange);
            document.addEventListener("webkitfullscreenchange", this.onFullscreenChange);
            document.addEventListener("mozfullscreenchange", this.onFullscreenChange);
            document.addEventListener("MSFullscreenChange", this.onFullscreenChange);
        },
        removeFullScreenEvent() {
            document.removeEventListener("fullscreenchange", this.onFullscreenChange);
            document.removeEventListener("webkitfullscreenchange", this.onFullscreenChange);
            document.removeEventListener("mozfullscreenchange", this.onFullscreenChange);
            document.removeEventListener("MSFullscreenChange", this.onFullscreenChange);
        },
        onFullscreenChange() {
            this.isFullScreen = !!document.fullscreenElement || !!document.webkitFullscreenElement || !!document.mozFullScreenElement || !!document.msFullscreenElement;
            console.log(this.isFullScreen);
        },
        onSwipeChange() {
            this.currentIndex = this.$refs.mySwiper.swiperInstance.realIndex;
            console.log("currentIndex", this.currentIndex);
            if (this.videoList.length > this.loadMoreCount) {
                if (this.loadedMoreCount !== this.videoList.length) {
                    if (this.videoList.length - 1 - this.currentIndex <= this.loadMoreCount) {
                        this.$emit("more");
                        this.loadedMoreCount = this.videoList.length;
                    }
                }
            }
        },
        onFullScreenClick() {
            this.isFullScreen = true;
        },
        onChangeCurrentVideoStatus() {
            if (this.isPlaying) {
                this.pause();
            } else {
                this.play();
            }
        },
        onShareClick(item) {
            let link = `https:// wzcjmp.rich0120.com/moment?share_id=${item.id}`;
            fnCopy(`${item.title}\n${link}`);
        },
        async onCollectClick(params) {
            if (!checkLoginWidthAppMessage()) {
                return;
            }
            let index = params.index;
            let isCollect = params.status;
            let video = params.video;
            if (!isCollect) {
                try {
                    await Dialog.confirm({
                        title: "是否取消收藏？"
                    });
                } catch (e) {
                    return;
                }
            }
            let res = await this.$axios("shorts/setShortsCollect", {
                params: {
                    shorts_id: video.id,
                    status: isCollect ? 1 : 2
                }
            })
            if (res.code === 10001) {
                video.is_collect = isCollect;
                if (isCollect) {
                    Toast.success("收藏成功");
                } else {
                    Toast.success("取消收藏");
                }
            }
        },
        onLikeClick(item) {
            this.$axios.get("shorts/addShortsLike", {
                params: {
                    shorts_id: item.id
                }
            })
        },
        onSelectClick(item) {
            if (item.jump_button_type == 0) return;
            if (!checkLoginWidthAppMessage()) {
                return;
            }
            sendAppMessage({jump_type: item.jump_button_type, jump_url: item.jump_button_url})
        },
        onBottomClick(item) {
            if (!item.bottom_bar_status) return;
            let teacher_id = item.teacher.id;
            this.$router.push("/moment/collection?teacher_id=" + teacher_id);
            // if(!checkLoginWidthAppMessage()) {
            //   return;
            // }
            // sendAppMessage({jump_type: 2, jump_url: teacher_id});
        },
        onGiveClick(item) {
            this.giftCourseId = item.gift_course_id;
            this.$nextTick(() => {
                this.$refs.myGiftPanel.open();
            })
        },
        generateVideoUrl(video) {
            const baseUrl = "https://mpv.videocc.net/";

            // 提取uid、视频类型和前缀
            const uid = video.vid.substring(0, 10);
            const type = video.vid.charAt(video.vid.indexOf("_") - 1);
            const vidPrefix = video.vid.split("_")[0];
            const video_format = video.video_format;

            // 拼接完整 URL
            return `${baseUrl}${uid}/${type}/${vidPrefix}_1.${video_format}`;
        },
        onBack() {
            if (this.backGoHome) {
                sendAppMessage({jump_type: 0, jump_url: ""});
            } else {
                this.$router.back();
            }
        },
        onClickCollect() {
            if (!checkLoginWidthAppMessage()) {
                return;
            }
            this.$router.replace("/moment/collect");
        },
        async onRefreshCommentList(item) {
            await this.onCommentClick(item);
            window.$bus.$emit("scrollToCommentBottom");
        },
        async onCommentClick(item) {
            let res = await this.$axios.get("/shorts/getShortsCommentList", {
                params: {shorts_id: item.id}
            })
            if (res.code == 10001) {
                this.$refs.myCommentPanel.showCommentPanel(item, res.data);
            }
        }
    }
};
</script>

<template>
    <div class="container">
        <div class="title">
            <div class="back" @click="onBack">
                <van-icon class="text-xl" size="26" color="#FFF" name="arrow-left"/>
            </div>
            <div v-if="showTitle" class="texts flex justify-center items-center space-x-8">
                <h1 style="color: #F00">今日集萃</h1>
                <h1 class="text-white" @click="onClickCollect">我的收藏</h1>
            </div>
        </div>
        <swiper ref="mySwiper" :options="swiperOption" class="mySwiper" @slideChange="onSwipeChange">
            <swiper-slide v-for="(video, index) in videoList" :key="video.id">
                <VideoSlideItem
                    ref="videoSlideItems"
                    :cache-index="getCacheIndex"
                    :current-index="currentIndex"
                    :giftOtherData="giftOtherData"
                    :index="index"
                    :is-full="isFullScreen"
                    :item="video"
                    :poster="video.img"
                    :src="generateVideoUrl(video)"
                    @bottom="onBottomClick"
                    @collect="onCollectClick"
                    @fullscreen="onFullScreenClick"
                    @give="onGiveClick"
                    @like="onLikeClick"
                    @select="onSelectClick"
                    @share="onShareClick"
                    @comment="onCommentClick"
                >
                </VideoSlideItem>
            </swiper-slide>
        </swiper>
        <GiftPanel ref="myGiftPanel" :course_id="giftCourseId"></GiftPanel>
        <CommentPanel ref="myCommentPanel"></CommentPanel>
    </div>
</template>

<style scoped>

.container {
    width: 100%;
    height: 100%;
}

.title {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 2;
    @apply h-14 flex items-center;
}

.title .texts {
    width: 100%;
}

.title h1 {
    @apply text-base;
    font-weight: bold;
}

.title .back {
    position: absolute;
    left: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
}

.mySwiper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: #000;
    overflow: hidden;
}

</style>
